import { render, staticRenderFns } from "./OurRecruitment.vue?vue&type=template&id=2a491e54&scoped=true&"
import script from "./OurRecruitment.vue?vue&type=script&lang=js&"
export * from "./OurRecruitment.vue?vue&type=script&lang=js&"
import style0 from "./OurRecruitment.vue?vue&type=style&index=0&id=2a491e54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a491e54",
  null
  
)

export default component.exports